module.exports = require('./BooleanCell');
